module.exports = require('./BooleanCell');
